// extracted by mini-css-extract-plugin
module.exports = {"wish":"a10a3f92e9--wish--PgxBi"};